import type { ThemeId } from '@whistler-ui/k2/constants/global';

import { ROLES } from '../constants/settings';

export const OrganisationType = {
  MNO: 'mno',
  MVNO: 'mvno',
  Other: 'other',
  WHOLESALE_MNO: 'wholesale_mno',
  WHOLESALE_MVNO: 'wholesale_mvno',
};

export type BusinessType =
  (typeof OrganisationType)[keyof typeof OrganisationType];

export type Status = 'Active' | 'Inactive';

export type NumberOfSubscribers =
  | 'lt_50000'
  | 'gt_50000_lt_100000'
  | 'gt_100000_lt_500000'
  | 'gt_500000_lt_1000000'
  | 'gt_1000000_lt_5000000'
  | 'gt_5000000_lt_10000000'
  | 'gt_10000000_lt_50000000'
  | 'gt_50000000_lt_100000000'
  | 'gt_100000000';

export type Address = {
  id: string;
  organisation_id?: string;
  address_line_1?: string;
  address_line_2?: string;
  city?: string;
  state?: string;
  postcode?: string;
  country?: string;
};

export const OrganisationStatus = {
  Draft: 'Draft',
  AwaitingApprovalBackoffice: 'AwaitingApprovalBackoffice',
  AwaitingApproval: 'AwaitingApproval',
  AwaitingOemApproval: 'AwaitingOemApproval',
  AwaitingPartnerApproval: 'AwaitingPartnerApproval',
  AwaitingOemRejection: 'AwaitingOemRejection',
  Trial: 'Trial',
  AwaitingProductionApproval: 'AwaitingProductionApproval',
  Production: 'Production',
  Suspended: 'Suspended',
  RejectedBackoffice: 'RejectedBackoffice',
  Rejected: 'Rejected',
  OnlyPartnerRejected: 'OnlyPartnerRejected',
  Live: 'Live',
} as const;

export type OrganisationStatusType =
  (typeof OrganisationStatus)[keyof typeof OrganisationStatus];

export type EntitlementServer =
  | 'NOT_SELECTED'
  | 'SPLIT_USE_CASE'
  | 'ENTITLEMENT_SERVER';

export type PartnerNameType = ThemeId;

export type RoleType = (typeof ROLES)[keyof typeof ROLES];

export type EligibleUseCase = {
  operating_system: string;
  device_transfer: boolean;
  atomic_device_transfer?: boolean;
  five_g: boolean;
  watch_activation: boolean;
  ipad_activation?: boolean;
  rcs_activation?: boolean;
  vo_wifi: boolean;
  vo_lte: boolean;
  vo_lte_default_on?: boolean;
  baseline: boolean;
};

export type SupportSla = 'Lite' | 'Silver';

export interface NetworkSettings {
  organisation_id: string;
  carrier_name: string;
  carrier_website_url: string;
  carrier_support_phone_number: string;
  android_carrier_id?: number;
  msisdn_length: number;
  default_smdp_fqdn: string;
  network_logo_url: string;
}

export interface User {
  id: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  phone?: string;
  job_title?: string;
  roles?: RoleType[];
  organisation_id: string;
  organisation_name?: string;
  status?: Status;
  internal_support_user?: boolean;
}
